<div class="stu-my-space">
  <div class="list-header">
    <button (click)="sendNewDocumentGAEvent()" class="spen-mod-btn is-primary" routerLink="/documents/new" data-cy="transit-form">
      活動記録の新規作成
    </button>
  </div>

  @if (unread_assessments_count > 0) {
    <div class="comment-count">
      <a data-cy="unread-assessments" (click)="getUnreadAssessments()"
        >{{ unread_assessments_count }}件の活動記録にコメントがありました。</a
      >
    </div>
  }

  @if (filterService.filtered) {
    <div class="filtered-category">
      <div class="change-filter">
        <a class="spen-util-link" data-cy="change-filter" (click)="filterService.showFilter()"
          ><i class="fa fa-search"></i>検索条件を変更</a
        >
      </div>
      <div class="category-detail">
        <span class="category-name" data-cy="text-filter">検索条件：{{ filterService.messageFilter }}</span>
        <a class="remove-filter spen-util-link" data-cy="remove-filter" (click)="removeCategoryFilter()">解除</a>
      </div>
    </div>
  } @else {
    <div class="not-filtered-category">
      <a class="spen-util-link" data-cy="show-filter" (click)="filterService.showFilter()"><i class="fa fa-search"></i>検索</a>
    </div>
  }

  <div class="activity-records-list">
    @if (dataLoaded) {
      @if (activityRecordsCount > 0) {
        <div class="list-amount">
          <span data-cy="list-item-count">{{ activityRecordsCount }}件</span>
        </div>
        <div class="space-content">
          <ul class="space-flex-list">
            @for (activityRecord of activityRecords; track activityRecord.id; let isFirst = $first) {
              <li class="list-item" data-cy="list-item" (click)="clickItem(activityRecord)" [class.is-first]="isFirst">
                <app-student-activity-item [activityRecord]="activityRecord"></app-student-activity-item>
              </li>
            }
          </ul>
          <div class="block-footer">
            @if (showPagination) {
              <div class="pagination">
                <spen-paginator [length]="page().total_pages" [pageIndex]="page().current_page - 1" (page)="pageChanged($event)" />
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="null-content">
          <img src="/assets/images/empty-content.png" />
          <div class="empty-message">
            <p>まずは『<a href="https://ed.classi.jp/student_howtouse_classi#mokuhyotateru">Classi活用ナビサイト</a>』</p>
            <p>で利用シーンを見てみましょう！</p>
          </div>
        </div>
      }
    } @else {
      <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
    }
  </div>
  @if (!isMobileApp) {
    <a href="{{ classiUrl }}" class="spen-mod-btn prev-button" data-cy="back-home">ホームへ戻る</a>
  }
</div>

@if (filterService.isShowingFilter) {
  <app-filter-by-multiple (submitFilter)="changeFilter($event)"> </app-filter-by-multiple>
}
